import { useState, useEffect } from 'react'
import { supabase } from '@/integrations/supabase/client'

export const useMaintenanceMode = () => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    checkMaintenanceMode()
    
    // Set up real-time subscription for maintenance mode changes
    const channel = supabase.channel('maintenance-mode')
      .on('broadcast', { event: 'maintenance-mode-changed' }, ({ payload }) => {
        setIsMaintenanceMode(payload.enabled)
      })
      .subscribe()

    return () => {
      supabase.removeChannel(channel)
    }
  }, [])

  const checkMaintenanceMode = async () => {
    try {
      // For now, we'll store this in localStorage as a simple implementation
      // In a real app, this would come from a system_settings table
      const maintenanceMode = localStorage.getItem('maintenance_mode') === 'true'
      setIsMaintenanceMode(maintenanceMode)
    } catch (error) {
      console.error('Error checking maintenance mode:', error)
      setIsMaintenanceMode(false)
    } finally {
      setLoading(false)
    }
  }

  const setMaintenanceMode = async (enabled: boolean) => {
    try {
      // Store in localStorage for demo purposes
      localStorage.setItem('maintenance_mode', enabled.toString())
      setIsMaintenanceMode(enabled)
      
      // Broadcast change to other tabs/windows
      const channel = supabase.channel('maintenance-mode')
      await channel.send({
        type: 'broadcast',
        event: 'maintenance-mode-changed',
        payload: { enabled }
      })
      
      return true
    } catch (error) {
      console.error('Error setting maintenance mode:', error)
      return false
    }
  }

  return {
    isMaintenanceMode,
    loading,
    setMaintenanceMode
  }
}